import { IOrder } from '../repository/OrderModel';

export const addressUpdateHandler = (order: IOrder): IOrder => {
    const deliveryAddress = { ...order.deliveryAddress, email: '' };
    return order.deliveryAddressSameAsBilling
        ? { ...order, deliveryAddress: { ...order.billingAddress, email: '' } }
        : { ...order, deliveryAddress };
};
